import { isBrowser } from './env'
import { paymentResultsPath } from 'callback/payment'
import { NextRouter } from 'next/router'
import { paymentTypes } from 'src/utils/payment'
import { isEmpty } from 'src/utils/string'
import { isObjectEmpty } from 'src/utils/object'
import { redirect } from 'src/utils/routes'

export const getCheckoutRedirectUrl = ({
  storeOrderId,
  router,
  enableNewCheckoutFlow = false,
  pageName
}: {
  storeOrderId: string
  router: NextRouter
  enableNewCheckoutFlow?: boolean
  pageName?: string
}): string => {
  if (!isBrowser()) return

  if (pageName === 'checkout') {
    return `${
      window.location.origin
    }${paymentResultsPath}/checkout/${storeOrderId}?locale=${
      router.query.locale
    }${enableNewCheckoutFlow ? '&step_payment=true' : ''}`
  } else if (pageName === 'invoice') {
    return `${
      window.location.origin
    }${paymentResultsPath}/invoice/${storeOrderId}/${
      router.query.hashCode
    }?locale=${router.query.locale}${
      enableNewCheckoutFlow ? '&step_payment=true' : ''
    }`
  }
}

export const redirectPage = ({
  redirectUrl,
  router,
  type,
  storeOrderId
}: {
  redirectUrl?: string
  router: NextRouter
  type: string
  storeOrderId?: string
}): void => {
  if (redirectUrl && isBrowser()) {
    window.location.href = redirectUrl
    if (storeOrderId) {
      window.localStorage.setItem(
        'hasRedirected',
        JSON.stringify({ [storeOrderId]: true })
      )
    }
  } else {
    redirect({
      url: `/[locale]/thankyou`,
      as: `/${router.query.locale}/thankyou?type=${type}${
        storeOrderId ? `&storeOrderId=${storeOrderId}` : ''
      }`,
      scroll: false
    })
  }
}

export const getUpdatedCustomer = ({ customer, values }) => {
  const _customer = { ...customer }
  let needUpdate = false

  if (!customer.acceptMarketingMenu && values.newsletterCheckbox) {
    _customer.acceptMarketingMenu = true
    needUpdate = true
  }

  // make sure to not compare empty value
  // i.e undefined !== null, it will return true
  if (!isEmpty(customer.phone) || !isEmpty(values.phone)) {
    if (customer.phone !== values.phone && !isEmpty(values.phone)) {
      _customer.phone = values.phone
      needUpdate = true
    }
  }

  if (
    !isEmpty(customer.organisationName) ||
    !isEmpty(values.organisationName)
  ) {
    if (customer.organisationName !== values.organisationName) {
      _customer.organisationName = values.organisationName
      needUpdate = true
    }
  }

  if (needUpdate) {
    return _customer
  }

  return null
}

export const shouldTriggerStripe3dsFlow = ({
  newPaymentWorkflow,
  paymentMethod,
  sourceId,
  storeOrderId,
  redirectError,
  metaError
}: {
  newPaymentWorkflow: boolean
  paymentMethod: number
  sourceId: string
  storeOrderId: string
  redirectError: string
  metaError: string | { errorCode: string }[]
}): boolean =>
  newPaymentWorkflow &&
  (paymentMethod === paymentTypes.stripe ||
    paymentMethod === paymentTypes.stripeExpressAccount) &&
  !isEmpty(sourceId) &&
  !isEmpty(storeOrderId) &&
  isEmpty(redirectError) &&
  isObjectEmpty(metaError)
